/******************************************************************************************
 *	License Admin Search Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.licenseAdminSearch', []).controller(
    'LicenseAdminSearchController',
    /* @ngInject */
    function(
      $log,
      $scope,
      $state,
      $locale,
      LICENSE_ADMIN_SEARCH_TYPES,
      LicenseAdminSearchCriteria,
      Settings,
      SspList,
      LicenseAdminSearch,
      CustomerSegments,
      User,
      BreadcrumbsMenu,
      CurtainNotifications,
      LicenseAdminSearchSnapshot,
      ResellerReminderModal
    ) {
      //Search state requires no impersonation
      BreadcrumbsMenu.clearPersistentItems(); //Remove reseller org name from breadcrumbs
      User.clearImpersonatedReseller(); //Clear impersonated reseller data

      //Make search criteria available in view
      $scope.LicenseAdminSearchCriteria = LicenseAdminSearchCriteria;
      $scope.searchOptions = LicenseAdminSearchCriteria.getOptions();
      $scope.resellersOnly = false;

      //Reset customer segment counters, to prevent them from persisting between different reseller orgs acceessed from search results
      CustomerSegments.resetCounters();

      $scope.showSearchResults = false; //Toggles search results table
      $scope.searchInProgress = false; //True when search is in progress, fales otherwise

      //Controls which results table is displayed.
      //There's are 2 tables: one for customers and one for resellers.
      //When set, a value from LICENSE_ADMIN_SEARCH_TYPES is assigned to it.
      $scope.searchType = null;

      //Submit
      //Control vars for UI validation errors
      $scope.searchSubmitAttempted = false; //Was submit button clicked?

      var resetSearchSubmit = function() {
        $scope.searchSubmitted = false;
        $scope.searchSubmitAttempted = false;
      };

      $scope.submitSearch = function() {
        if (!$scope.searchSubmitted) {
          $scope.searchSubmitAttempted = true;

          if ($scope.searchForm.$valid) {
            $scope.searchSubmitted = true;
            $scope.searchInProgress = true;

            //Hide current search results table upon submit
            $scope.showSearchResults = false;

            //Persistence
            LicenseAdminSearchSnapshot.setSearchCriteria($scope.searchCriteria);
            LicenseAdminSearchSnapshot.setSearchTerm($scope.searchTerm);

            //Structure data as needed by API
            var payload = {
              qField: $scope.searchCriteria.value,
              q: $scope.searchTerm
            };

            $log.info('%cLA search payload ::', 'font-weight:bold;color:#009966;', payload);

            //POST to service
            LicenseAdminSearch.get($scope.searchCriteria.searchType, payload)
              .then(function(responseData) {
                initSearchResults(responseData);
                $scope.searchResultCount = responseData.length;
                $scope.noSearchData = false;
                $scope.showSearchResults = true;
              })
              .catch(function(response) {
                $log.error('Failed to perform search', response.data);

                if (response.status !== 0) {
                  //status is 0 when call is aborted
                  if (
                    response.status === 400 &&
                    response.data.errorCode === 'INVALID_SEARCH_CRITERIA'
                  ) {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                  } else if (response.status === 404) {
                    $scope.searchErrorMessage = 'global.dataList.emptyMessages.noResultsFound';
                    $scope.noSearchData = true;
                    $scope.showSearchResults = true;

                    //Sorting arrow from a previous sort would persist otherwise on the no-data table
                    if ($scope.searchResults) {
                      $scope.searchResults.sort = null;
                    }
                  } else if (response.status === 504) {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'licenseAdminSearch.notifications.gatewayTimeout'
                    );
                  } else {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                  }
                }
              })
              .finally(function() {
                //Tell the view what kind of search type is being performed
                //This is set after data is fetched so that the view doesn't change the table before new data is in.
                $scope.searchType = $scope.searchCriteria.searchType;

                //Allow new searches
                resetSearchSubmit();

                $scope.searchInProgress = false;
              });
          }
        }
      };

      //Team Members Data List init and refresh
      var searchResultsDataList;
      var refreshDataList = function(options) {
        $scope.searchResults = searchResultsDataList.get(options);
        if (!$scope.searchResults.data.length) {
          $scope.noSearchResults = true;
          $scope.searchErrorMessage = 'global.dataList.emptyMessages.noResultsFound';
        } else {
          $scope.noSearchResults = false;
        }

        //Persistence
        //Placed in refreshDataList() rather than the initSearchResults() so that
        //we are storing the latest changes to the dataset
        LicenseAdminSearchSnapshot.setSearchResults(searchResultsDataList);
      };

      var initSearchResults = function(data) {
        searchResultsDataList = new SspList(data, {
          itemsPerPage: Settings.itemsPerPage.default
        });

        refreshDataList({page: 1});
      };

      //Pagination
      $scope.prevPage = function() {
        var page = $scope.searchResults.pagination.currentPage - 1;
        refreshDataList({page: page});
      };
      $scope.nextPage = function() {
        var page = $scope.searchResults.pagination.currentPage + 1;
        refreshDataList({page: page});
      };

      //Sorting
      $scope.sort = function(column, serverColumns, isNumeric) {
        refreshDataList({sortBy: column, sortNumeric: isNumeric});
      };

      //Search
      $scope.search = function(query) {
        refreshDataList({query: query});
      };
      $scope.clearSearch = function() {
        searchResultsDataList.clearSearch();
        refreshDataList();
      };

      /*=== Table Action Buttons ===*/
      //View Details
      $scope.resellerAction = function(event, reseller) {
        if (reseller.active && !reseller.hideActionButton) {
          //If Ctrl+Click, or third mouse button click let the browser handle the click event by opening a new tab
          //Otherwise, preventDefault() and handle the click to save state.
          if (!event.ctrlKey && event.button !== 1) {
            event.preventDefault();

            $state.go('licenseAdmin.impersonatedReseller.dashboard', {
              resellerID: reseller.id
            });
          }
        }
      };

      $scope.customerAction = function(event, customer) {
        if (!customer.hideActionButton) {
          //If Ctrl+Click, or third mouse button click let the browser handle the click event by opening a new tab
          //Otherwise, preventDefault() and handle the click to save state.
          if (!event.ctrlKey && event.button !== 1) {
            event.preventDefault();

            $state.go('licenseAdmin.impersonatedReseller.customerDetails', {
              resellerID: customer.resellerId,
              customerID: customer.id
            });
          }
        }
      };

      /*=== Snapshot restoration ===*/
      //If a snapshot is found, it will restore search results, sorting and pagination.
      var restoreSnapshot = function() {
        //Attempt to restore search criteria and search term from snapshot
        $scope.searchCriteria = LicenseAdminSearchSnapshot.getSearchCriteria();
        $scope.searchTerm = LicenseAdminSearchSnapshot.getSearchTerm();
        //Attempt to restore search results from snapshot
        searchResultsDataList = LicenseAdminSearchSnapshot.getSearchResults();
        if (searchResultsDataList) {
          refreshDataList();
          $scope.searchResultCount = searchResultsDataList.getOriginalDataset().length;
          $scope.noSearchData = false;
          $scope.showSearchResults = true;

          //Tell the view what kind of search type is being performed
          $scope.searchType = $scope.searchCriteria.searchType; //$scope.searchCriteria was just set above
        }
      };
      restoreSnapshot();

      /*=== Reseller Remidner ===*/
      $scope.resellerReminder = function(event, reseller) {
        event.preventDefault();

        if (!reseller.active) {
          var locals = {
            reseller: {
              id: reseller.id,
              email:
                reseller.primaryAdmin && reseller.primaryAdmin.email
                  ? reseller.primaryAdmin.email
                  : null,
              name: reseller.name,
              lastInviteDate: reseller.lastInviteDate
            }
          };

          ResellerReminderModal.create(locals).then(function(data) {
            if (data && !data.cancelled) {
              if (!reseller.primaryAdmin) {
                reseller.primaryAdmin = {};
              }
              reseller.primaryAdmin.email = data.response.email;
              reseller.lastInviteDate = data.response.lastInviteDate;
            }
          });
        }
      };

      /*=== Clean-up ===*/
      $scope.$on('$destroy', function() {
        //Remove any modals if visible, otherwise navigation (via back / forward arrows) would preserve the modal over other views
        ResellerReminderModal.remove();
      });
    }
  );
})();
